import { FaceIdProfileDetails } from '@/features/face-id-profiles';

const FaceIdProfileDetailsPage = () => {
  return <FaceIdProfileDetails />;
};

export default FaceIdProfileDetailsPage;
